import { SravniNewsSharedEnumsOrganizationType } from '../__generated__/news/Api';

export const GROUP_NAME_BY_TYPE = {
  [SravniNewsSharedEnumsOrganizationType.Bank]: 'Банки',
  [SravniNewsSharedEnumsOrganizationType.Broker]: 'Брокеры',
  [SravniNewsSharedEnumsOrganizationType.Insurance]: 'Страховые компании',
  [SravniNewsSharedEnumsOrganizationType.Mfo]: 'МФО',
  [SravniNewsSharedEnumsOrganizationType.Other]: 'Прочее',
  [SravniNewsSharedEnumsOrganizationType.School]: 'Школы',
};

export const MAP_TYPE_TO_URL = {
  [SravniNewsSharedEnumsOrganizationType.Bank]: 'bank',
  [SravniNewsSharedEnumsOrganizationType.Broker]: 'broker',
  [SravniNewsSharedEnumsOrganizationType.Insurance]: 'strakhovaja-kompanija',
  [SravniNewsSharedEnumsOrganizationType.Mfo]: 'mfo',
  [SravniNewsSharedEnumsOrganizationType.School]: 'shkola',
};
